/* global rp$, window, document */
'use strict';

const getGarageStore = () => import(
	'public/js/components/garage-store.js'
);

const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const utils = require('public/js/helpers/utils');

function handleGarageUpdated(eventOrGarage, maybeGarage, ...rest) {
	const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
	const garageTitleComponents = document.querySelectorAll('.garage-title-component');
	if (!garageTitleComponents.length) {
		return;
	}
	garageTitleComponents.forEach((garageTitleComponent) => {
		const garageLinkFlyoutWrap = garageTitleComponent.querySelector('[data-garage-link-wrap="flyout"]');
		const garageLinkPickerWrap = garageTitleComponent.querySelector('[data-garage-link-wrap="picker"]');
		if (!garageLinkFlyoutWrap || !garageLinkPickerWrap) {
			return;
		}
		const flyoutText = garageLinkFlyoutWrap.querySelector('.garage-title-text');
		if (garage.length === 0 || !flyoutText) {
			garageLinkFlyoutWrap.hidden = true;
			garageLinkPickerWrap.hidden = false;
			return;
		}

		const selectedCar = garage.find((car) => car?.selected) || null;
		const selectedLabel = (() => {
			if (!selectedCar) 
				return null;
			if (typeof selectedCar.ui_short === 'string' && selectedCar.ui_short !== '') 
				return selectedCar.ui_short;
			const parts = [
				selectedCar.ui_year || selectedCar.year,
				selectedCar.ui_make || selectedCar.make,
				selectedCar.ui_model || selectedCar.model,
			].filter(Boolean);
			return parts.length ? String(parts.join(' ')) : null;
		})();

		const nextText = selectedLabel || garageLinkFlyoutWrap?.dataset?.searchAllText || '';
		flyoutText.textContent = nextText;
		garageLinkPickerWrap.hidden = true;
		garageLinkFlyoutWrap.hidden = false;
	});
}

function attachEvents() {
	getGarageStore().then((module) => {
		const rp_garage_store = module?.handleGarageData ?? null;
		if (!rp_garage_store || typeof rp_garage_store.getGarageData !== 'function') {
			return;
		}

		rp$(document)
			.off('garageUpdated.garageTitle')
			.on('garageUpdated.garageTitle', handleGarageUpdated);

		const titleComponent = document.querySelector('.garage-title-component');
		const isVehicleSpecificPage = utils.isTruthyDataValue(titleComponent?.dataset?.isVehicleSpecificPage);
		const garage = rp_garage_store.getGarageData(isVehicleSpecificPage);
		if (garage) {
			handleGarageUpdated(garage);
		}
	}).catch(() => {
		// ignore
	});
}

runScriptOnReady('garage_title_component', attachEvents);

